import Alpine from "alpinejs";

Alpine.store("mapPopup", {
  metaobject: null,
  mapTouched: false,
  popupOpen: false,
  popupLoading: false,
  imagePopupOpen: false,
  data: null,
  map: null,
  showAllProducts: false,
  hoverData: null,
  hoverActiveData: null,
  hoverOpened: false,

  init() {
    const url = new URL(window.location.href)

    try {
      const origin = url.searchParams.get('origin')
      const coordinates = JSON.parse(url.searchParams.get('coordinates'))

      if (origin && coordinates) {
        document.addEventListener('alpine:initialized', () => {
          this.openPopup(origin, coordinates)
        })

        document.addEventListener('DOMContentLoaded', () => {
          this.map.map.on('load', () => {
            this.map.highlightOrigin(origin, coordinates)
          })
        })
      }
    } catch (e) {

    }
  },

  async openPopup(handle, coordinates, hoverData) {
    this.popupOpen = true
    this.popupLoading = true

    this.hoverActiveData = hoverData

    const url = new URL(window.location.href)
    url.searchParams.set('origin', handle)
    url.searchParams.set('coordinates', JSON.stringify(coordinates))
    window.history.replaceState(null, null, url)

    const shopifyResponse = await Alpine.store('main').graphQl(`
      query MyQuery {
        metaobject(
          handle: {handle: "${handle}", type: "origin_page_details_popup"}
        ) {
          title: field(key: "title") {
            value
          }
          location: field(key: "location") {
            value
          }
          region: field(key: "region") {
            value
          }
          elevation: field(key: "elevation") {
            value
          }
          copy: field(key: "copy") {
            value
          }
          products: field(key: "products") {
            references(first: 20) {
              nodes {
                ... on Product {
                  title
                  onlineStoreUrl
                  featuredImage {
                    url(transform: {maxWidth: 200, preferredContentType: WEBP})
                    width
                    height
                  }
                  tea_type: metafield(key: "tea_type", namespace: "my_fields") {
                    value
                  }
                  tasting_notes: metafield(key: "tasting_notes", namespace: "my_fields") {
                    value
                  }
                }
              }
            }
          }
          images: field(key: "images") {
            references(first: 20) {
              nodes {
                ... on MediaImage {
                  id
                  image {
                    url(transform: {preferredContentType: WEBP})
                    smallUrl: url(transform: {maxWidth: 1000, preferredContentType: WEBP})
                    width
                    height
                  }
                }
                ... on Video {
                  id
                  sources {
                    format
                    height
                    mimeType
                    url
                    width
                  }
                  previewImage {
                    url(transform: {preferredContentType: WEBP})
                    smallUrl: url(transform: {maxWidth: 1000, preferredContentType: WEBP})
                  }
                }
              }
            }
          }
          articles: field(key: "articles") {
            references(first: 20) {
              nodes {
                ... on Metaobject {
                  image: field(key: "image") {
                    reference {
                      ... on MediaImage {
                        id
                        image {
                          url(transform: {maxWidth: 200, preferredContentType: WEBP})
                          width
                          height
                        }
                      }
                    }
                  }
                  title: field(key: "title") {
                    value
                  }
                  upper_label: field(key: "upper_label") {
                    value
                  }
                  link: field(key: "link") {
                    value
                  }
                }
              }
            }
          }
        }
      }
    `)

    this.data = {
      ...shopifyResponse?.data?.metaobject,
      hoverData,
    }
    Alpine.store('main').isNavScrolled = true
    this.popupLoading = false
  },

  closePopup() {
    this.popupOpen = false
    this.imagePopupOpen = false
    this.showAllProducts = false
    this.map?.onPopupClosed()
    this.closeHoverPopup()
    Alpine.store('main').onScroll()

    const url = new URL(window.location.href)
    url.searchParams.delete('origin')
    url.searchParams.delete('coordinates')
    window.history.replaceState(null, null, url)
  },


  openHoverPopup({ title, content, left, top }) {
    this.hoverData = { title, content, left, top }
    this.hoverOpened = true
  },

  closeHoverPopup() {
    this.hoverOpened = false
  }
})
